class DataType {
    static BOOLEAN = 'boolean';
    static NUMBER = 'number';
    static STRING = 'string';
    static TEXT = 'text';
    static DATE = 'date';
    static TIME = 'time';
    static DATETIME = 'datetime';
    static CURRENCY = 'currency';
    static TAG = 'tag';

    static get(code) {
        return TYPE_MAP[code];
    }
}

const TYPE_MAP = {
    'varchar': DataType.STRING,
    'decimal': DataType.NUMBER,
    'bigint': DataType.STRING,
    'char': DataType.STRING,
    'int': DataType.NUMBER,
    'currency': DataType.CURRENCY,
    'date': DataType.DATE,
    'datetime': DataType.DATETIME,
    'float': DataType.NUMBER,
    'json': null,
    'text': DataType.TEXT,
    'tag': DataType.TAG,
}

export default DataType;